import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=04917d00&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=04917d00&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04917d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04917d00')) {
      api.createRecord('04917d00', component.options)
    } else {
      api.reload('04917d00', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=04917d00&scoped=true", function () {
      api.rerender('04917d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/mallManagement/orderList/detail.vue"
export default component.exports